import { useRouter } from 'next/router';

const useFindLocation = () => {
	const { pathname, query } = useRouter();

	const isSearchPage = pathname.includes('/search');
	const isStoresPage = pathname.includes('/stores') && !query?.all?.length;
	const isStoreDetailsPage = pathname.includes('/stores') && !query?.all?.length;
	const isEntekhabinoPage = pathname.includes('/entekhabino');
	const isEntekhabPage = pathname.includes('/entekhab');
	const isDigiKalaPage = pathname.includes('/digikala');
	const isRegistration = pathname.includes('/landing/medu');
	const isFara = pathname.includes('/landing/fara');

	return {
		isSearchPage,
		isStoresPage,
		isStoreDetailsPage,
		isEntekhabinoPage,
		isEntekhabPage,
		isDigiKalaPage,
		isRegistration,
		isFara,
	};
};
export default useFindLocation;
